import React,{Component} from 'react';
 import {Grid, Container, Box} from '@material-ui/core';
 import FooterNav from './FooterNav'
 
 class Footer extends Component{
     render(){
         const {isLoggedIn } = this.props;
         return(
            <Container style={{padding:'9px 100px 10px 100px',background:'#fff', minWidth:this.props.location.pathname==="/dashboard"? "1200px":null, maxWidth:this.props.location.pathname==="/dashboard"? "100%":null}}>
                 <Box display="flex" my={1}>
                     <Grid item md style={{width:'100%'}}>
                         <FooterNav isLoggedIn={isLoggedIn} />
                     </Grid>
                 </Box>
             </Container>
           
         )
     }
 }
 
export default Footer;